import { jwtDecode } from "jwt-decode";

/** Forme minimale d'un access_token Keycloak : on ne lit que les rôles de realm. */
type RealmAccessPayload = {
    realm_access?: {
        roles?: string[];
    };
};

/**
 * Décode un access_token Keycloak et renvoie ses rôles de realm (`realm_access.roles`).
 * Pure : ne lève jamais — renvoie `[]` si le token est absent, malformé ou dépourvu de rôles.
 */
export function getRealmRolesFromToken(
    accessToken: string | null | undefined,
): string[] {
    if (!accessToken) {
        return [];
    }

    try {
        const payload = jwtDecode<RealmAccessPayload>(accessToken);
        return payload?.realm_access?.roles ?? [];
    } catch {
        return [];
    }
}

/**
 * Indique si l'access_token Keycloak porte le rôle de realm `role`.
 * Pure : ne lève jamais (token absent/malformé → `false`).
 */
export function hasRealmRole(
    accessToken: string | null | undefined,
    role: string,
): boolean {
    return getRealmRolesFromToken(accessToken).includes(role);
}
